<template>
  <component :is="userData === undefined ? 'div' : 'b-card'">

    <!-- Alert: No item found -->
    <b-alert
      variant="danger"
      :show="userData === undefined"
    >
      <h4 class="alert-heading">
        Error fetching user data
      </h4>
      <div class="alert-body">
        No user found with this user id. Check
        <b-link
          class="alert-link"
          :to="{ name: 'admin-users-list'}"
        >
          User List
        </b-link>
        for other users.
      </div>
    </b-alert>

    <b-tabs
      v-if="userData"
      pills
    >

      <!-- Tab: Account -->
      <b-tab active>
        <template #title>
          <i class="fas fa-hospital-alt cursor-pointer" ></i>
          <span class="d-none d-sm-inline">Account</span>
        </template>
        <FacilityEditTabAccount
          :facilityData="userData"
          class="mt-2 pt-75"
        />
      </b-tab>
    </b-tabs>
  </component>
</template>

<script>
import {
  BTab, BTabs, BCard, BAlert, BLink,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import router from '@/router'
import FacilityEditTabAccount from './FacilityEditTabAccount.vue'

import axiosF from '@/core/services/api/admin/facilities'

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,

    FacilityEditTabAccount,
  },
  setup() {
    const userData = ref(null)

    // Get user data
    axiosF.facilityDetail(router.currentRoute.params.id).then((response) => {
      userData.value = response.registro
    })

    /* store.dispatch('app-user/fetchUser', { id: router.currentRoute.params.id })
      .then(response => { userData.value = response.data })
      .catch(error => {
        if (error.response.status === 404) {
          userData.value = undefined
        }
      }) */

    return {
      userData,
    }
  },
}
</script>

<style>

</style>
